export default __webpack_public_path__ + "static/media/tv-woonkamer.21874556.jpg";